export const getPersonas = (orderCounts) => {
  const { organizerOrderCount = 0, recipientOrderCount = 0 } = orderCounts || {};
  let personas = "";
  if (organizerOrderCount) {
    personas += "organizer";
  }
  if (recipientOrderCount) {
    personas += personas ? ", recipient" : "recipient";
  }
  return personas;
};

export const getEventTargetLocation = ({ componentName, elementPosition }) =>
  [componentName, elementPosition].filter(Boolean).join("-");
